import { createFileRoute } from '@tanstack/react-router';

import { EncountersPage } from '@/features/emr';

export const Route = createFileRoute('/_authenticated/encounters/list')({
  component: EncountersPage,
  beforeLoad: () => ({
    breadcrumbs: [
      { title: 'Inbox', href: '/encounters' },
      { title: 'Encounter list', href: '/encounters/list' },
    ],
  }),
});
